import React, { useState } from "react";
import { Box, Button, TextField } from "@mui/material";
import request from "../../../api/request";
import "./ChangePasswordPage.css";
import md5 from "md5";
import { BackendAPI } from "../../../const/api";
import { useToast } from "../../../component/ToastBar";

const ChangePasswordPage = () => {
  const toast = useToast();
  const [passwords, setPasswords] = useState({
    currentPassword: "",
    newPassword: "",
    confirmPassword: "",
  });
  const [error, setError] = useState("");

  const handlePasswordChange = (psw, confirm = false) => {
    if (confirm) {
      setPasswords({ ...passwords, confirmPassword: psw });
    } else {
      setPasswords({ ...passwords, newPassword: psw });
    }
    if (confirm && psw !== passwords.newPassword) {
      setError("两次密码输入不一致");
      return;
    }
    if (psw === passwords.currentPassword) {
      setError("新密码不能和旧密码相同");
      return;
    }
    // 执行密码格式校验
    if (!validatePassword(psw)) {
      setError("密码必须包含至少6位字母和数字的组合");
    } else {
      setError("");
    }
  };

  const validatePassword = (psw) => {
    return /^(?=.*[A-Za-z])(?=.*\d).{6,}$/.test(psw);
  };

  const validateForm = () => {
    if (
      !passwords.currentPassword ||
      !passwords.newPassword ||
      !passwords.confirmPassword
    ) {
      setError("所有字段必须填写。");
      return false;
    }
    if (passwords.newPassword === passwords.currentPassword) {
      setError("新密码不能和旧密码相同");
      return;
    }
    if (passwords.newPassword !== passwords.confirmPassword) {
      setError("两次密码输入不一致");
      return false;
    }
    if (!validatePassword(passwords.newPassword)) {
      setError("密码必须包含至少6位字母和数字的组合。");
      return false;
    }
    setError("");
    return true;
  };

  const handleInputChange = (e) => {
    setPasswords({ ...passwords, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) {
      return;
    }

    // Add validation logic here (e.g., check if new passwords match)

    try {
      const encryptedCurrent = md5(passwords.currentPassword);
      const encryptedNew = md5(passwords.newPassword);
      await request
        .put(BackendAPI.userPassword, {
          currentPassword: encryptedCurrent,
          newPassword: encryptedNew,
        })
        .then((res) => {
          if (res.success) {
            if (res.message) {
              toast(res.message);
            } else {
              // Handle success (clear form, show success message, etc.)
              setPasswords({
                currentPassword: "",
                newPassword: "",
                confirmPassword: "",
              });
              toast("密码修改成功");
            }
          }
        });
    } catch (error) {
      console.error("Error changing password:", error);
      // Handle error (show error message, etc.)
      setError(`密码修改失败: ${error}`);
    }
  };

  return (
    <Box
      component="form"
      noValidate
      onSubmit={handleSubmit}
      className="change-password-form"
    >
      <TextField
        label="当前密码"
        type="password"
        name="currentPassword"
        autoComplete="password"
        value={passwords.currentPassword}
        onChange={handleInputChange}
      />
      <TextField
        label="新密码"
        type="password"
        name="newPassword"
        value={passwords.newPassword}
        onChange={(e) => handlePasswordChange(e.target.value)}
      />
      <TextField
        label="确认新密码"
        type="password"
        name="confirmPassword"
        value={passwords.confirmPassword}
        onChange={(e) => handlePasswordChange(e.target.value, true)}
      />
      {error && <p className="error-message">{error}</p>}
      <Button type="submit" variant="contained">
        修改密码
      </Button>
    </Box>
  );
};

export default ChangePasswordPage;
